import React, { useState } from "react";
import "./MotorCycle.css";
import { Link } from "react-router-dom";
/* ---------------- MOTORCYCLE DATA ---------------- */
import HeroSplendorPlus from "../../assets/HeroSplendorPlus.png";
import HondaShine from "../../assets/HondaShine.png";
import BajajPulsar150 from "../../assets/BajajPulsar150.png";
import TVSApacheRTR160 from "../../assets/TVSApacheRTR160.png";
import YamahaFZ from "../../assets/YamahaFZ.png";
import HondaUnicorn from "../../assets/HondaUnicorn.png";
import HeroPassionPro from "../../assets/HeroPassionPro.png";
import TVSRaider125 from "../../assets/TVSRaider125.png";
import YamahaMT15 from "../../assets/YamahaMT15.png";
import RoyalEnfieldClassic350 from "../../assets/RoyalEnfieldClassic350.png";
import KTMDuke200 from "../../assets/KTMDuke200.png";
import BajajPlatina110 from "../../assets/BajajPlatina110.png";

import BajajFreedom125CNG from "../../assets/BajajFreedom125CNG.png";
import HeroSplendorCNG from "../../assets/HeroSplendorCNG.png";
import TVSStarCityCNG from "../../assets/TVSStarCityCNG.png";
import HeroPassionCNG from "../../assets/HeroPassionCNG.png";
import HondaShineCNG from "../../assets/HondaShineCNG.png";
import BajajDiscoverCNG from "../../assets/BajajDiscoverCNG.png";
import HeroHFDeluxeCNG from "../../assets/HeroHFDeluxeCNG.png";
import TVSRadeonCNG from "../../assets/TVSRadeonCNG.png";
import HondaLivoCNG from "../../assets/HondaLivoCNG.png";
import HeroGlamourCNG from "../../assets/HeroGlamourCNG.png";
import BajajCT125CNG from "../../assets/BajajCT125CNG.png";
import TVSSportCNG from "../../assets/TVSSportCNG.png";

import RevoltRV400 from "../../assets/RevoltRV400.png";
import TorkKratos from "../../assets/TorkKratos.png";
import UltravioletteF77 from "../../assets/UltravioletteF77.png";
import HopOxo from "../../assets/HopOxo.png";
import ObenRorr from "../../assets/ObenRorr.png";
import MatterAera from "../../assets/MatterAera.png";
import KabiraKM3000 from "../../assets/KabiraKM3000.png";
import KabiraKM4000 from "../../assets/KabiraKM4000.png";
import JoyMonster from "../../assets/JoyMonster.png";
import TorqueDrift from "../../assets/TorqueDrift.png";
import EmfluxOne from "../../assets/EmfluxOne.png";
import PureEVEtryst from "../../assets/PureEVEtryst.png";
const motorcycleData = [
  /* Petrol Motorcycles */

  {
    id: 1,
    name: "Hero Splendor Plus",
    capacity: "2 Passenger",
    fuel: "Petrol",
    type: "Petrol Motorcycle",
    price: 190,
    image: HeroSplendorPlus,
  },
  {
    id: 2,
    name: "Honda Shine",
    capacity: "2 Passenger",
    fuel: "Petrol",
    type: "Petrol Motorcycle",
    price: 195,
    image: HondaShine,
  },
  {
    id: 3,
    name: "Bajaj Pulsar 150",
    capacity: "2 Passenger",
    fuel: "Petrol",
    type: "Petrol Motorcycle",
    price: 1110,
    image: BajajPulsar150,
  },
  {
    id: 4,
    name: "TVS Apache RTR 160",
    capacity: "2 Passenger",
    fuel: "Petrol",
    type: "Petrol Motorcycle",
    price: 1115,
    image: TVSApacheRTR160,
  },
  {
    id: 5,
    name: "Yamaha FZ",
    capacity: "2 Passenger",
    fuel: "Petrol",
    type: "Petrol Motorcycle",
    price: 1120,
    image: YamahaFZ,
  },
  {
    id: 6,
    name: "Honda Unicorn",
    capacity: "2 Passenger",
    fuel: "Petrol",
    type: "Petrol Motorcycle",
    price: 1105,
    image: HondaUnicorn,
  },
  {
    id: 7,
    name: "Hero Passion Pro",
    capacity: "2 Passenger",
    fuel: "Petrol",
    type: "Petrol Motorcycle",
    price: 190,
    image: HeroPassionPro,
  },
  {
    id: 8,
    name: "TVS Raider 125",
    capacity: "2 Passenger",
    fuel: "Petrol",
    type: "Petrol Motorcycle",
    price: 1110,
    image: TVSRaider125,
  },
  {
    id: 9,
    name: "Yamaha MT 15",
    capacity: "2 Passenger",
    fuel: "Petrol",
    type: "Petrol Motorcycle",
    price: 1140,
    image: YamahaMT15,
  },
  {
    id: 10,
    name: "Royal Enfield Classic 350",
    capacity: "2 Passenger",
    fuel: "Petrol",
    type: "Petrol Motorcycle",
    price: 180,
    image: RoyalEnfieldClassic350,
  },
  {
    id: 11,
    name: "KTM Duke 200",
    capacity: "2 Passenger",
    fuel: "Petrol",
    type: "Petrol Motorcycle",
    price: 1200,
    image: KTMDuke200,
  },
  {
    id: 12,
    name: "Bajaj Platina 110",
    capacity: "2 Passenger",
    fuel: "Petrol",
    type: "Petrol Motorcycle",
    price: 180,
    image: BajajPlatina110,
  },

  /* CNG Motorcycles */

  {
    id: 13,
    name: "Bajaj Freedom 125 CNG",
    capacity: "2 Passenger",
    fuel: "CNG",
    type: "CNG Motorcycle",
    price: 185,
    image: BajajFreedom125CNG,
  },
  {
    id: 14,
    name: "Hero Splendor CNG",
    capacity: "2 Passenger",
    fuel: "CNG",
    type: "CNG Motorcycle",
    price: 180,
    image: HeroSplendorCNG,
  },
  {
    id: 15,
    name: "TVS Star City CNG",
    capacity: "2 Passenger",
    fuel: "CNG",
    type: "CNG Motorcycle",
    price: 178,
    image: TVSStarCityCNG,
  },
  {
    id: 16,
    name: "Hero Passion CNG",
    capacity: "2 Passenger",
    fuel: "CNG",
    type: "CNG Motorcycle",
    price: 182,
    image: HeroPassionCNG,
  },
  {
    id: 17,
    name: "Honda Shine CNG",
    capacity: "2 Passenger",
    fuel: "CNG",
    type: "CNG Motorcycle",
    price: 184,
    image: HondaShineCNG,
  },
  {
    id: 18,
    name: "Bajaj Discover CNG",
    capacity: "2 Passenger",
    fuel: "CNG",
    type: "CNG Motorcycle",
    price: 180,
    image: BajajDiscoverCNG,
  },
  {
    id: 19,
    name: "Hero HF Deluxe CNG",
    capacity: "2 Passenger",
    fuel: "CNG",
    type: "CNG Motorcycle",
    price: 175,
    image: HeroHFDeluxeCNG,
  },
  {
    id: 20,
    name: "TVS Radeon CNG",
    capacity: "2 Passenger",
    fuel: "CNG",
    type: "CNG Motorcycle",
    price: 178,
    image: TVSRadeonCNG,
  },
  {
    id: 21,
    name: "Honda Livo CNG",
    capacity: "2 Passenger",
    fuel: "CNG",
    type: "CNG Motorcycle",
    price: 182,
    image: HondaLivoCNG,
  },
  {
    id: 22,
    name: "Hero Glamour CNG",
    capacity: "2 Passenger",
    fuel: "CNG",
    type: "CNG Motorcycle",
    price: 186,
    image: HeroGlamourCNG,
  },
  {
    id: 23,
    name: "Bajaj CT 125 CNG",
    capacity: "2 Passenger",
    fuel: "CNG",
    type: "CNG Motorcycle",
    price: 170,
    image: BajajCT125CNG,
  },
  {
    id: 24,
    name: "TVS Sport CNG",
    capacity: "2 Passenger",
    fuel: "CNG",
    type: "CNG Motorcycle",
    price: 172,
    image: TVSSportCNG,
  },

  /* Electric Motorcycles */

  {
    id: 25,
    name: "Revolt RV400",
    capacity: "2 Passenger",
    fuel: "Electric",
    type: "Electric Motorcycle",
    price: 1150,
    image: RevoltRV400,
  },
  {
    id: 26,
    name: "Tork Kratos",
    capacity: "2 Passenger",
    fuel: "Electric",
    type: "Electric Motorcycle",
    price: 1160,
    image: TorkKratos,
  },
  {
    id: 27,
    name: "Ultraviolette F77",
    capacity: "2 Passenger",
    fuel: "Electric",
    type: "Electric Motorcycle",
    price: 1200,
    image: UltravioletteF77,
  },
  {
    id: 28,
    name: "Hop Oxo",
    capacity: "2 Passenger",
    fuel: "Electric",
    type: "Electric Motorcycle",
    price: 1140,
    image: HopOxo,
  },
  {
    id: 29,
    name: "Oben Rorr",
    capacity: "2 Passenger",
    fuel: "Electric",
    type: "Electric Motorcycle",
    price: 1150,
    image: ObenRorr,
  },
  {
    id: 30,
    name: "Matter Aera",
    capacity: "2 Passenger",
    fuel: "Electric",
    type: "Electric Motorcycle",
    price: 1170,
    image: MatterAera,
  },
  {
    id: 31,
    name: "Kabira KM3000",
    capacity: "2 Passenger",
    fuel: "Electric",
    type: "Electric Motorcycle",
    price: 1165,
    image: KabiraKM3000,
  },
  {
    id: 32,
    name: "Kabira KM4000",
    capacity: "2 Passenger",
    fuel: "Electric",
    type: "Electric Motorcycle",
    price: 1180,
    image: KabiraKM4000,
  },
  {
    id: 33,
    name: "Joy Monster",
    capacity: "2 Passenger",
    fuel: "Electric",
    type: "Electric Motorcycle",
    price: 1140,
    image: JoyMonster,
  },
  {
    id: 34,
    name: "Torque Drift",
    capacity: "2 Passenger",
    fuel: "Electric",
    type: "Electric Motorcycle",
    price: 1135,
    image: TorqueDrift,
  },
  {
    id: 35,
    name: "Emflux One",
    capacity: "2 Passenger",
    fuel: "Electric",
    type: "Electric Motorcycle",
    price: 1220,
    image: EmfluxOne,
  },
  {
    id: 36,
    name: "Pure EV Etryst",
    capacity: "2 Passenger",
    fuel: "Electric",
    type: "Electric Motorcycle",
    price: 1145,
    image: PureEVEtryst,
  },
];

/* ---------------- COMPONENT ---------------- */

const MotorCycle = () => {
  const [fuelType, setFuelType] = useState("Petrol");

  const filteredMotorcycles = motorcycleData.filter(
    (bike) => bike.fuel === fuelType,
  );

  return (
    <div className="motorcycle-page">
      <div className="motorcycle-buttons">
        <button className="petrol-btn" onClick={() => setFuelType("Petrol")}>
          Petrol
        </button>
        <button className="cng-btn" onClick={() => setFuelType("CNG")}>
          CNG
        </button>
        <button
          className="electric-btn"
          onClick={() => setFuelType("Electric")}
        >
          Electric
        </button>
      </div>

      <div className="motorcycle-grid">
        {filteredMotorcycles.map((bike) => (
          <Link
            to="/bike-traveller-rental-detail-page"
            className="scooter-ride-link"
            state={{
              carData: bike,
              totalPrice: bike.price, // ✅ sending price
            }}
            key={bike.id}
          >
            {" "}
            <div className="motorcycle-card" key={bike.id}>
              <div className="tag-left">{bike.type}</div>
              <div className="tag-right">₹{bike.price}</div>

              <div className="motorcycle-image-div">
                {" "}
                <img src={bike.image} alt={bike.name} />
              </div>

              <h3>{bike.name}</h3>
              <p>{bike.capacity}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default MotorCycle;
